import { Switch } from '@headlessui/react';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';

interface CheckboxProps {
  checked: boolean;
  id: string;
  label: string;
  value: string;
  onChange: () => void;
}

export default function InnerCheckbox({
  checked,
  id,
  label,
  value,
  onChange,
}: CheckboxProps) {
  return (
    <Switch.Group>
      <div className='flex w-full items-center justify-between gap-md'>
        <Switch.Label>
          <Typography>{label}</Typography>
        </Switch.Label>
        <Switch
          id={id}
          checked={checked}
          onClick={onChange}
          value={value}
          className={`
            relative flex h-5 w-5 items-center justify-center rounded-sm outline-none ring-2 
            transition-all duration-200 ${!checked ? `ring-mono-color-dark` : ''} 
            ${checked ? 'ring-color-brand-primary bg-color-brand-primary' : ''}
          `}
        >
          <Icon
            Icon='check'
            type='material'
            className={`${
              checked ? 'scale-100' : 'scale-0'
            } text-mono-color-white transition-transform duration-200 ease-out`}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
}
